module.exports = __webpack_public_path__ + "static/media/suly.4433154c.png";